import { render, staticRenderFns } from "./ResidentialBadge.vue?vue&type=template&id=3b6e6484&scoped=true"
import script from "./ResidentialBadge.vue?vue&type=script&lang=js"
export * from "./ResidentialBadge.vue?vue&type=script&lang=js"
import style0 from "./ResidentialBadge.vue?vue&type=style&index=0&id=3b6e6484&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e6484",
  null
  
)

export default component.exports